import { Box, Chip, CircularProgress, Typography } from "@material-ui/core"
import React from "react"

/** Formata epoch/ISO em data+hora curtas pt-BR. */
export function fmtData(v: any): string {
    if (!v) return ""
    try {
        const d = typeof v === "number" ? new Date(v) : new Date(v)
        if (isNaN(d.getTime())) return String(v)
        return d.toLocaleString("pt-BR", {
            day: "2-digit",
            month: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
        })
    } catch {
        return String(v)
    }
}

export function erroMsg(e: any): string {
    return (
        e?.response?.data?.mensagem ||
        e?.response?.data?.message ||
        (typeof e?.response?.data === "string" ? e.response.data : "") ||
        e?.message ||
        "Erro inesperado."
    )
}

const CORES: Record<string, "default" | "primary" | "secondary"> = {
    PENDENTE: "secondary",
    EM_ATENDIMENTO: "primary",
    FECHADO: "default",
    high: "secondary",
    medium: "primary",
    low: "default",
}

export function StatusChip({ valor }: { valor?: string }) {
    if (!valor) return null
    return <Chip size="small" label={valor} color={CORES[valor] || "default"} />
}

export function Carregando({ ativo }: { ativo: boolean }) {
    if (!ativo) return null
    return (
        <Box display="flex" justifyContent="center" p={3}>
            <CircularProgress size={28} />
        </Box>
    )
}

export function Vazio({ texto }: { texto: string }) {
    return (
        <Typography color="textSecondary" variant="body2" style={{ padding: 16, textAlign: "center" }}>
            {texto}
        </Typography>
    )
}
